import React from 'react';

export const ListCheckIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/list/checked' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          id='ci:list-check'
          transform='translate(2.500000, 6.666667)'
          fill='currentColor'
          fillRule='nonzero'
        >
          <path
            d='M11.2599206,12.7480159 L0.0992063492,12.7480159 L0.0992063492,10.2678571 L11.2599206,10.2678571 L11.2599206,12.7480159 Z M16.2202381,7.78769841 L0.0992063492,7.78769841 L0.0992063492,5.30753968 L16.2202381,5.30753968 L16.2202381,7.78769841 Z M16.2202381,2.82738095 L0.0992063492,2.82738095 L0.0992063492,0.347222222 L16.2202381,0.347222222 L16.2202381,2.82738095 Z'
            id='Shape'
          ></path>
        </g>
        <polygon
          id='Path-Copy-5'
          fill='#5EB523'
          points='17.799596 19.4953037 19.2552258 18.037615 20.5790872 19.3635353 25.7345285 14.2163294 27.18707 15.6750476 20.5790872 22.2737654'
        ></polygon>
      </g>
    </svg>
  );
};
